/**
 * Dashboard page root component
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import history from '../history'
import * as _ from 'lodash'
import generate from 'firebase-auto-ids'

import Layout from '../shared/Layout'
import Header from '../dashboard/DashboardHeader'
import Sidebar from '../dashboard/DashboardSidebar'
import Main from '../dashboard/DashboardMain'
import CreateAppModal from '../dashboard/CreateAppModal'
import InstagramWizard from '../dashboard/InstagramWizard'
import MobileAppWizard from '../dashboard/MobileAppWizard'
import { getTemplatesInfo, getTemplateInfo } from 'templates/templates'
import { formatMillisecondsDate } from 'utils/editorUtils'
import { createNewApp } from 'controllers/logic'
import { changeEditorScene } from 'actions/locationAC'
import * as templateCategory from 'constants/templateCategory'
import config from 'config'

const templates = getTemplatesInfo()

class Dashboard extends Component {

  constructor () {
    super()

    this.state = {
      selectedTemplateId: '',
      selectedAppId: '',
      isModalOpen: false,
    }
  }

  selectTemplate = (templateId) => this.setState({ selectedTemplateId: templateId, selectedAppId: '' })

  selectApp = (appId) => this.setState({ selectedAppId: appId, selectedTemplateId: '' })

  openModal = () => this.setState({ isModalOpen: true })

  closeModal = () => this.setState({ isModalOpen: false })

  createApp = (appId, appName, customFields = {}) => {
    this.closeModal()
    if (appId && appName && this.state.selectedTemplateId) {
      console.log('createApp', appId, appName, customFields)
      this.props.dispatch(createNewApp(appId, appName, this.state.selectedTemplateId, customFields))
    }
  }

  editApp = () => {
    this.props.dispatch(changeEditorScene(0))
    history.push('/app/' + this.state.selectedAppId)
  }

  processApps (apps = {}) {
    return Object.keys(apps).map(key => (
      {
        id: key,
        title: apps[key].name,
        image: `https://firebasestorage.googleapis.com/v0/b/${config.storageBucket}/o/templates%2FoutSide%2Fbg-intro.jpg?alt=media&token=84f13400-81b0-49b6-a601-7c257690e8db`,
        lastModified: formatMillisecondsDate(apps[key].lastModified),
        published: apps[key].published,
        integrations: (_.has(apps[key], ['customFields', 'appSettings', 'integration', 'type']))
          ? [ apps[key].customFields.appSettings.integration.type ] : [],
        templateId: apps[key].templateId,
        customFields: apps[key].customFields
      }
    ))
  }

  createAppPressed = () => {
    const { selectedTemplateId } = this.state
    const template = getTemplateInfo(selectedTemplateId)
    if (selectedTemplateId) {
      if (template.category === templateCategory.INSTAGRAM_SHOPPABLE ||
          template.category === templateCategory.MOBILE_APP_LANDING) {
        this.openModal()
      } else {
        const appId = generate(_.now())
        const appName = null
        this.props.dispatch(createNewApp(appId, appName, selectedTemplateId, {}))
      }
    }
  }

  renderMain () {
    const { selectedAppId, selectedTemplateId } = this.state
    const selectedCard = (selectedTemplateId === '')
      ? this.processApps(this.props.apps).find(app => app.id === selectedAppId)
      : getTemplateInfo(selectedTemplateId)
    return (
      <Main
        selectedCard={selectedCard}
        createApp={this.createAppPressed}
        editApp={this.editApp}
      />
    )
  }

  renderCreateAppModal () {
    const { selectedTemplateId, isModalOpen } = this.state
    if (isModalOpen) {
      const template = getTemplateInfo(selectedTemplateId)
      let Modal = CreateAppModal
      if (template.category === templateCategory.INSTAGRAM_SHOPPABLE) Modal = InstagramWizard
      if (template.category === templateCategory.MOBILE_APP_LANDING) Modal = MobileAppWizard
      return (
        <Modal
          templateId={selectedTemplateId}
          handleCreateApp={this.createApp}
          handleCancel={this.closeModal}
        />
      )
    }
  }

  render () {
    return (
      <Layout
        header={<Header />}
        sidebar={
          <Sidebar
            templates={templates}
            apps={this.processApps(this.props.apps)}
            selectedTemplateId={this.state.selectedTemplateId}
            selectedAppId={this.state.selectedAppId}
            selectTemplate={this.selectTemplate}
            selectApp={this.selectApp}
            tabName={this.props.match.params.tab}
          />
        }
        main={this.renderMain()}
        modal={this.renderCreateAppModal()}
      />
    )
  }
}

Dashboard.propTypes = {
  match: PropTypes.object.isRequired,
  apps: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  apps: state.apps
})

export default connect(mapStateToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard.js